<div *ngIf="!isOpened">
  <div class="row px-1">
    <div class="only-button d-flex justify-content-end container-style px-2 py-1">
      <app-custom-button class="widthBtns pt-1 pb-1" [width]="'5rem'" [title]="'Nuevo'" [label]="'Nuevo'"
        [severity]="'success'" [variant]="undefined" [icon]="'pi pi-plus'" [width]="'5.5rem'"
        (onClick)="openModalInventoryClass()"></app-custom-button>
      <app-custom-modal #inventoryClassModal [label]="'Captura Clase Inventario'" [header]="'Captura Clase Inventario'"
        [children]="componentRegisterInventoryClass" [inputs$]="inputsForInventoryClass$" [width]="'30vw'"
        [output$]="inputsForInventoryClass$" hidden></app-custom-modal>
    </div>
  </div>
  <div class="container-style mt-2">
    <app-custom-table [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
      [previousFilters]="filters" [filterPersistentKey]="url" (onRecoverData)="getInventoryClassesForConsultation()"
      (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>